import React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, Redirect } from 'react-router-dom';
// import './DocumentViewer/DocumentViewer.css';

import AppMenu from './AppMenu/AppMenu';
import DashboardView from './Dashboard/DashboardView';
import WarPanel from './War/WarPanel';
import DocumentViewerModal from './DocumentViewer/DocumentViewerModal';
import Agenda from '../PrivateArea/Meeting/components/Agenda';
import CloseAppModal from "./CloseAppModal/CloseAppModal"
import store from '../../stores/store';
// import uuid from '../../helpers/uuid';

import ProfileView from './Profile/ProfileView';
//import NotFound from '../_shared/NotFound';

import VoteDetails from '../PrivateArea/Vote/VoteDetails';

// if we want to automatically redirect to dashboard - use <Redirect to="/dashboard"/>
// if we want to show NotFound with AppMenu - use <Route component={NotFound}/>
const PrivateArea = observer(
    class PrivateArea extends React.Component {

        componentDidMount() {
            if (window.offlineApiExtension) {
                window.offlineApiExtension.syncRead();
            }
        }

        render() {
            return (
                <div
                    className={
                        'container-fluid ' +
                        (store.documents.loadingDocument ? ' document-modal-loader' : '')
                    }
                >
                    <Route path="/" component={AppMenu} />
                    <Switch>
                        <Route path="/profile" component={ProfileView} />
                        <Route path="/wortharead" component={WarPanel} />
                        {store.meetings.selectedId !== null ? (
                            <Route path="/dashboard/meetings/agenda" component={Agenda} />
                        ) : null}
                         {store.votes.selectedId !== null ? (
                            <Route path="/dashboard/vote/votedetails" component={VoteDetails} />
                        ) : null}
                        <Route path="/dashboard" component={DashboardView} />
                        <Redirect to="/dashboard" />
                        {/*<Route component={NotFound}/>*/}
                    </Switch>
                    <CloseAppModal show={store.user.shouldShowCloseAppModal} />

                    {store.documents.isViewerModalOpen ? (
                        <DocumentViewerModal
                            onClose={store.documents.closeViewerModal}
                            document={store.documents.currentDocument}
                        />
                    ) : null}
                </div>
            );
        }
    },
);

export default PrivateArea;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/PrivateArea.js